import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainAxios } from "../../app/api";
import service from "../../config.json";
import { errorToast } from "../../helpers/toaster";
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};
const {
  getSignature,
  getAirHotelData,
  transferSearch,
  transferSearchReturn,
  transferBook,
  transferReturnBook,
} = service;

const initialState = {
  transferBookings: [],
  travellersCount: 1,
  loading: true,
  signature: "",
  listData: "",
  searchedTransfers: [],
  bookingStatus: {},
  message: "",
  status: 0,
};

export const setSignature = createAsyncThunk(
  "transfer/setSignature",
  async () => {
    const { Authorization } =
      JSON.parse(sessionStorage.getItem("userData")) || {};
    try {
      const res = await mainAxios.get(getSignature, {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {}
  }
);

export const fetchAirHotelData = createAsyncThunk(
  "transfer/fetchAirHotelData",
  async (state) => {
    const { data, Authorization } = state || {};
    try {
      const res = await mainAxios.post(getAirHotelData, data, {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {}
  }
);

// transferSearchAsync
export const transferSearchAsync = createAsyncThunk(
  "transfer/transferSearchAsync",
  async (state) => {
    try {
      const { signatureData, depature, Authorization } = state;
      const { timestamp, token } = signatureData;

      const res = await mainAxios.post(
        transferSearch,
        {
          Departure: depature,
        },
        {
          headers: {
            Authorization,
            Timestamp: timestamp,
            signature: token,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// transferSearchReturnAsync
export const transferSearchReturnAsync = createAsyncThunk(
  "transfer/transferSearchReturnAsync",
  async (state) => {
    const { depature, returnJourney, signatureData, Authorization } = state;

    const { timestamp, token } = signatureData;

    try {
      const res = await mainAxios.post(
        transferSearchReturn,
        {
          Departure: depature,
          Return: returnJourney,
        },
        {
          headers: {
            Authorization,
            Timestamp: timestamp,
            signature: token,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// transferSearchReturnAsync
export const transferBookAsync = createAsyncThunk(
  "transfer/transferBookAsync",
  async (state) => {
    const { travelData } = state || {};
    let Transfer = {};
    const { Vehicles, JourneyDetail } = state.BookingData;
    let { Title, FirstName, LastName, Email, MobileNo, CountryCode } =
      state.state;
    MobileNo = MobileNo.concat(CountryCode);
    const {
      booking_date,
      booking_time,
      return_date,
      return_time,
      from_place,
      to_place,
      total_traveller,
    } = travelData || {};

    const { timestamp, token } = state.signatureData;
    const { Authorization, pickUpDesp } = state;
    Transfer.Vehicle = Vehicles[0];
    Transfer.Vehicle.VehicleCount = 1;
    Transfer.JourneyDetail = JourneyDetail;

    if (pickUpDesp === "TransferAirportDetail") {
      Transfer.JourneyDetail.PickupDescription = state.state.AirlineCode;
      Transfer.JourneyDetail.DropoffDescription = `${state.state.HotelAddress} - ${state.state.ZipCode}`;
    } else {
      Transfer.JourneyDetail.PickupDescription = `${state.state.HotelAddress} - ${state.state.ZipCode}`;
      Transfer.JourneyDetail.DropoffDescription = state.state.AirlineCode;
    }

    const PassengerDetails = { Title, FirstName, LastName, Email, MobileNo };

    const TrackingId = state.TrackingId;

    try {
      const res = await mainAxios.post(
        transferBook,
        {
          Transfer,
          PassengerDetails,
          TrackingId,
          booking_date,
          booking_time,
          return_date,
          return_time,
          from_place,
          to_place,
          total_traveller,
          from: pickUpDesp === "TransferAirportDetail" ? "Airport" : "Hotel",
          to: pickUpDesp === "TransferAirportDetail" ? "Hotel" : "Airport",
        },
        {
          headers: {
            Timestamp: timestamp,
            signature: token,
            Authorization,
          },
        }
      );

      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// transferReturnBookAsync
export const transferReturnBookAsync = createAsyncThunk(
  "transfer/transferReturnBookAsync",
  async (state) => {
    let Transfer = {};
    const { travelData } = state || {};
    const { Vehicles, JourneyDetail } = state.BookingData;
    const { Title, FirstName, LastName, Email, MobileNo } = state.state;

    const { timestamp, token } = state.signatureData;
    const { Authorization, pickUpDesp } = state;

    const {
      booking_date,
      booking_time,
      return_date,
      return_time,
      from_place,
      to_place,
      total_traveller,
    } = travelData || {};

    //Transfer
    Transfer.Vehicle = Vehicles[0];
    Transfer.Vehicle.VehicleCount = 1;
    Transfer.JourneyDetail = JourneyDetail;

    if (pickUpDesp === "TransferAirportDetail") {
      Transfer.JourneyDetail.PickupDescription = state.state.AirlineCode;
      Transfer.JourneyDetail.DropoffDescription = `${state.state.HotelAddress} - ${state.state.ZipCode}`;
    } else {
      Transfer.JourneyDetail.PickupDescription = `${state.state.HotelAddress} - ${state.state.ZipCode}`;
      Transfer.JourneyDetail.DropoffDescription = state.state.AirlineCode;
    }

    //return transfer
    let ReturnTransfer = {};
    ReturnTransfer.Vehicle = state.returnData.Vehicles[0];
    ReturnTransfer.Vehicle.VehicleCount = 1;
    ReturnTransfer.JourneyDetail = state.returnData.JourneyDetail;

    //remaining
    if (pickUpDesp === "TransferAirportDetail") {
      ReturnTransfer.JourneyDetail.PickupDescription = `${state.state.HotelAddress} - ${state.state.ZipCode}`;
      ReturnTransfer.JourneyDetail.DropoffDescription = state.state.AirlineCode;
    } else {
      ReturnTransfer.JourneyDetail.PickupDescription = state.state.AirlineCode;
      ReturnTransfer.JourneyDetail.DropoffDescription = `${state.state.HotelAddress} - ${state.state.ZipCode}`;
    }

    // state.state.AirlineCode;

    const PassengerDetails = { Title, FirstName, LastName, Email, MobileNo };

    const TrackingId = state.TrackingId;

    try {
      const res = await mainAxios.post(
        transferReturnBook,
        {
          Transfer,
          PassengerDetails,
          TrackingId,
          ReturnTransfer,
          booking_date,
          booking_time,
          return_date,
          return_time,
          from_place,
          to_place,
          total_traveller,
          from: pickUpDesp === "TransferAirportDetail" ? "Airport" : "Hotel",
          to: pickUpDesp === "TransferAirportDetail" ? "Hotel" : "Airport",
        },
        {
          headers: {
            Timestamp: timestamp,
            signature: token,
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

export const transferSlice = createSlice({
  name: "transfer",
  initialState,
  reducers: {
    incCount: (state) => {
      state.travellersCount = state.travellersCount + 1;
    },
    decCount: (state) => {
      state.travellersCount = state.travellersCount - 1;
    },
    setTravellersCount: (state, { payload }) => {
      state.travellersCount = parseInt(payload);
    },
    resetTransferBooked: (state) => {
      state.bookingStatus = {};
    },
    resetListData: (state) => {
      state.listData = [];
    },
  },
  extraReducers: {
    [setSignature.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        sessionStorage.setItem("signatureData", JSON.stringify(payload?.data));
        return { ...state, signature: payload.data };
      }
    },

    [fetchAirHotelData.fulfilled]: (state, { payload }) => {
      return { ...state, listData: payload.data };
    },
    [transferSearchAsync.pending]: (state) => {
      return { ...state, loading: true, searchedTransfers: [] };
    },
    [transferSearchAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, loading: false, searchedTransfers: payload.data };
      } else {
        errorToast("Some thing went wrong, Please try after some time");
        return { ...state, loading: false, searchedTransfers: [] };
      }
    },
    [transferSearchReturnAsync.pending]: (state) => {
      return { ...state, loading: true, searchedTransfers: [] };
    },
    [transferSearchReturnAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, loading: false, searchedTransfers: payload.data };
      } else {
        return { ...state, loading: false, searchedTransfers: [] };
      }
    },
    [transferBookAsync.pending]: (state) => {
      return { ...state, loading: true, bookingStatus: {} };
    },
    [transferBookAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return {
          ...state,
          loading: false,
          bookingStatus: payload.data,
          status: 200,
        };
      } else {
        if (parseInt(payload.status) === 300) {
          return {
            ...state,
            loading: false,
            bookingStatus: false,
            message: payload.data.message,
            status: payload.status,
          };
        } else {
          return {
            ...state,
            loading: false,
            bookingStatus: false,
            message: payload.data.message,
            status: payload.status,
          };
        }
      }
    },
    [transferReturnBookAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [transferReturnBookAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return {
          ...state,
          loading: false,
          bookingStatus: payload.data,
          status: 200,
        };
      } else {
        if (parseInt(payload.status) === 300) {
          return {
            ...state,
            loading: false,
            bookingStatus: false,
            message: payload.data.message,
            status: payload.status,
          };
        } else {
          return {
            ...state,
            loading: false,
            bookingStatus: false,
            message: payload.data.message,
            status: payload.status,
          };
        }
      }
    },
  },
});

export const getTravellers = (state) => {
  return state.transfer.travellersCount;
};

export const getListData = (state) => {
  return state.transfer.listData;
};

export const getSearchedTransfers = (state) => {
  return state.transfer.searchedTransfers;
};

export const getLoading = (state) => {
  return state.transfer.loading;
};

export const getSignatureData = (state) => {
  return state.transfer.signature;
};

export const getBookingStatus = (state) => {
  return state.transfer.bookingStatus;
};

// Action creators are generated for each case reducer function
export const {
  incCount,
  decCount,
  setTravellersCount,
  resetTransferBooked,
  resetListData,
} = transferSlice.actions;

export default transferSlice.reducer;
